const LOGO_SRC = `${process.env.PUBLIC_URL}/brand/bigbrand-logo.png`;

const BrandLogo = ({
  height,
  width,
  theme = "light",
  className = "",
  alt = "BIGBRAND",
  style = {},
}) => {
  const filter =
    theme === "dark"
      ? "invert(1)"
      : undefined;

  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      className={className}
      style={{
        height: height ?? (width ? "auto" : 28),
        width: width ?? "auto",
        filter,
        ...style,
      }}
      draggable={false}
    />
  );
};

export default BrandLogo;
